import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import NewAnnouncementsForm from "./NewAnnouncementsForm";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";

const AnnouncementsForm = () => {
  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 12,
      id: 1,
      component: <NewAnnouncementsForm />,
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default AnnouncementsForm;
